module.exports = __webpack_public_path__ + "static/media/SmartShop_4-338w.cc4fae81.png";